const ISO_TS_RGX =
  /^\d{4}-\d{2}-\d{2}T\d{2}:\d{2}:\d{2}(?:\.\d+)?(?:Z|[+-]\d{2}:\d{2})?$/;

/**
 * Devuelve una etiqueta legible según la granularidad pedida.
 * @param iso ISO-8601 string
 * @param granularity  "day" | "month" | "minute" | "hour" | "week"
 * @param locale  ej. 'es-AR'
 */
function formatByGranularity(
  iso: string,
  granularity: string,
  locale = 'es-AR'
): string {
  const d = new Date( iso );

  switch ( granularity ) {
    case 'month':
      // «Ene '25»
      return d.toLocaleDateString( locale, {
        month: 'short',
        year: '2-digit'
      });
    case 'minute':
      // «14:37»
      return d.toLocaleTimeString( locale, { hour: '2-digit', minute: '2-digit' });
    case 'hour':
      // «14h 23/05»
      return `${d.toLocaleTimeString( locale, { hour: '2-digit' })} ${d.toLocaleDateString(
        locale,
        { day: '2-digit', month: '2-digit' }
      )}`;
    case 'week':
      // usa el día de inicio de la semana – simplificamos a dd/mm
      return d.toLocaleDateString( locale, { day: '2-digit', month: '2-digit' });
    case 'day':
    default:
      // «23/05/25»
      return d.toLocaleDateString( locale, {
        day: '2-digit',
        month: '2-digit',
        year: '2-digit'
      });
  }
}

/**
 * Normaliza un array de objetos, formateando campos con fechas ISO-8601.
 * @param data               Datos brutos del backend
 * @param dateRange?         widgetDefinition.dateRange (puede ser undefined)
 */
export function parseDates(
  data: Record<string, unknown>[],
  dateRange?: {
    field: string;
    granularity?: { unit: string; value?: number };
  } | null
) {
  const targetField = dateRange?.field;
  const targetUnit = dateRange?.granularity?.unit ?? 'day';
  return data.map(( row ) => {
    const parsed: Record<string, unknown> = { ...row };

    Object.entries( parsed ).forEach(([ key, val ]) => {
      if ( typeof val === 'string' && ISO_TS_RGX.test( val )) {
          // Si coincide con dateRange.field usa su granularidad, si no → formato por defecto (dd/mm/yy).
          const unitForThisKey = key === targetField ? targetUnit : 'day';
          parsed[key] = formatByGranularity( val, unitForThisKey );
      }
    });

    return parsed;
  });
}